module.exports = __webpack_public_path__ + "img/products_big_can_dragonfruit_ru.e7648339.png";